export default __webpack_public_path__ + "d655eab3e61ff35d5847a47b3fa25298.png";